import { dispatchPanelPath } from "./dispatchPanelRoute";

/**
 * Where a link to a channel lands.
 *
 * A driver's channel opens in the Dispatch page's History pane when the workspace has the page on, and in the driver
 * list's channel view otherwise; a channel with no driver (a team's, a group's) opens in the channel view either way,
 * since the Dispatch page shows drivers only. One rule for every link into a channel from outside the page: search
 * results, the picture-in-picture window, and whatever comes next.
 *
 * @param link - The channel, its driver's membership when it is a driver's, and whether the Dispatch page is on.
 */
export function channelPath(link: {
  workspaceId: string;
  feedId: string;
  aliasMembershipId: string | null | undefined;
  dispatchEnabled: boolean;
}): string {
  const { workspaceId, feedId, aliasMembershipId, dispatchEnabled } = link;
  if (!aliasMembershipId) {
    return `/workspaces/${workspaceId}/channels/${feedId}`;
  }
  if (dispatchEnabled) {
    return dispatchPanelPath(workspaceId, aliasMembershipId, feedId, "history", null);
  }
  return `/workspaces/${workspaceId}/drivers/${aliasMembershipId}/channel/${feedId}`;
}
